import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { Header } from "@/components/Header";
import { OfflineBanner } from "@/components/OfflineBanner";
import { CopilotFloating } from "@/components/Copilot";

// Préchargement en arrière-plan des morceaux lourds (graphiques, tableaux de bord) une fois l'écran affiché.
function usePrefetchDashboards() {
  useEffect(() => {
    const run = () => { import("recharts"); import("@/pages/Dashboard"); import("@/pages/Strides"); import("@/pages/Ghs"); import("@/pages/Crisis"); };
    const id = "requestIdleCallback" in window ? window.requestIdleCallback(run, { timeout: 4000 }) : setTimeout(run, 2500);
    return () => ("cancelIdleCallback" in window ? window.cancelIdleCallback(id) : clearTimeout(id));
  }, []);
}

export default function Layout() {
  usePrefetchDashboards();
  return (
    <div className="min-h-screen flex bg-[#F6F7F9]">
      <Sidebar />
      <CopilotFloating />
      <div className="flex-1 ml-64">
        <Header />
        <OfflineBanner />
        <main className="p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
